import { useCallback, useEffect, useState } from 'react'
import { debounce } from "lodash";

type UseDebouncedStateReturnType<T> = {
  state: T,
  debouncedState: T,
  setState: (value: T) => void
}

export function useDebouncedState<T>(initialState: T, timeout: number, onDebounce: () => void = () => { }): UseDebouncedStateReturnType<T> {
  const [state, setState] = useState(initialState)
  const [debouncedState, setDebouncedState] = useState(initialState)

  /* eslint-disable-next-line */
  const debouncedSetState = useCallback(debounce(newState => {
    setDebouncedState(newState)
    onDebounce()
  }, timeout), [])

  useEffect(() => {
    return () => debouncedSetState.cancel()
  }, [debouncedSetState])

  return {
    state,
    debouncedState,
    setState: (value: T) => {
      setState(value)
      debouncedSetState(value)
    }
  }
}
